import { defineMessages } from 'react-intl';

export default defineMessages({
  hasSpecialEducationalNeeds: 'Specjalne potrzeby edukacyjne',
});
